export const statusMap = {
  1: {
    text: '预警',
    color: '#EB4141',
    backgroundColor: '#f5e7e5'
  },
  2: {
    text: '正常',
    color: '#32B357',
    backgroundColor: '#eaf7ee'
  }
}
